import React from 'react';
import { Img } from 'react-image';
import { Link, useSearchParams } from 'react-router-dom';
import { DyteClock, DyteParticipantCount } from '@dytesdk/react-ui-kit';
import { useDyteMeeting } from '@dytesdk/react-web-core';
import { Navbar } from 'flowbite-react';
import Recording from './indicator/Recording';
import { useThemeContext } from 'src/context/ThemeProvider';

type Props = {
	joined: boolean;
	showNavbar?: boolean;
};

const InterviewNavbar = ({ joined, showNavbar = true }: Props) => {
	const dyteMeeting = useDyteMeeting();
	const { themeMode } = useThemeContext();
	return (
		<div className="flex justify-between items-center dark:text-white">
			{showNavbar && (
				<Navbar
					className={`rounded-none w-full !px-[45px] sm:!px-[10px] bg-white dark:bg-[#18222D]`}
					fluid={true}
					rounded={true}
				>
					<div className="flex gap-8 items-center ">
						<Link to="/" className="flex items-center ">
							<Img
								loading="lazy"
								src={
									themeMode === 'dark'
										? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
										: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
								}
								width="110"
								height="32px"
								alt="LevelUp Logo"
							/>
						</Link>
						{joined && <Recording />}
					</div>
					<div className="text-base">{dyteMeeting.meeting.meta.meetingTitle}</div>
					{joined && (
						<div className="flex gap-4">
							<DyteParticipantCount meeting={dyteMeeting.meeting} />
							<DyteClock meeting={dyteMeeting.meeting} />
						</div>
					)}
				</Navbar>
			)}
		</div>
	);
};

export default InterviewNavbar;
